import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAuth } from "../hooks/UserAuthProvider";
import { useHistory } from "react-router-dom";
import {
  CheckOutlined,
  CloseOutlined,
  FormOutlined,
  UserOutlined,
} from "@ant-design/icons";
import ViewModal from "./Map/container/ViewModal";
import { inputValidation } from "./Map/utils";
import LogoutContent from "./LogoutContent";
import UserAvatar from "./UserAvatar";
import { getUser, refreshToken, userUpdate } from "../services/services";

const UserProfile = () => {
  const { userData, updateUser, tokens, isAuthenticated } = useAuth();
  const [editUser, setEditUser] = useState(false);

  const [name, setName] = useState(userData?.name ?? "Loading...");
  const [surname, setSurname] = useState(userData?.surname ?? "Loading...");
  const [email, setEmail] = useState(userData?.address ?? "Loading...");
  const [address, setAddress] = useState(userData?.email ?? "Loading...");

  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");

  const [nameError, setNameError] = useState(null);
  const [surnameError, setSurnameError] = useState(null);
  const [addressError, setAddressError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [verifyPasswordError, setVerifyPasswordError] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showUserEditSuccessModal, setShowUserEditSuccessModal] =
    useState(false);
  const [showUserEditFailedModal, setShowUserEditFailedModal] = useState(false);

  const menuItems = [
    { title: "Προφίλ", clickable: false },
    {
      title: "Αποσύνδεση",
      clickable: true,
      action: () => {
        setShowLogoutModal(true);
      },
    },
  ];

  const renderMenuItems = () => {
    return menuItems.map((menuItem, id) => {
      return (
        <MenuItem
          key={id}
          $isClickable={menuItem.clickable}
          as={menuItem.clickable ? "button" : "div"}
          type={menuItem.clickable ? "button" : undefined}
          onClick={() => {
            if (menuItem.clickable) {
              menuItem.action();
            }
          }}
        >
          <MenuTitle>{menuItem.title}</MenuTitle>
        </MenuItem>
      );
    });
  };

  const handleUserUpdate = async () => {
    const checkAccessToken = () => {
      const storeToken = tokens.accessToken;
      const localToken = localStorage.getItem("accessToken");
      return storeToken === localToken ? storeToken : localToken;
    };

    let isPasswordUpdated = false;
    if (password.length > 0 && verifyPassword.length > 0) {
      isPasswordUpdated = true;
    }
    const newUserObject = {
      first_name: name,
      last_name: surname,
      address,
    };
    if (isPasswordUpdated) {
      newUserObject["password"] = password;
    }

    await userUpdate(newUserObject, checkAccessToken()).then((response) => {
      if (response) {
        setShowUserEditSuccessModal(true);
        updateUser({
          name: newUserObject.first_name,
          surname: newUserObject.last_name,
          address: newUserObject.address,
        });
      } else {
        setShowUserEditFailedModal(true);
      }
    });
  };

  useEffect(() => {
    const getUserData = async (token) => {
      const user = await getUser(token).then((response) => {
        if (response) {
          setName(response.first_name);
          setSurname(response.last_name);
          setAddress(response.address);
          setEmail(response.email);
        }
      });
    };
    const accessToken = localStorage.getItem("accessToken");
    const user = JSON.parse(localStorage.getItem("user"));

    if (isAuthenticated) {
      setName(userData?.name);
      setSurname(userData?.surname);
      setAddress(userData?.address);
      setEmail(userData?.email);
    } else if (user) {
      setName(user.name);
      setSurname(user.surname);
      setAddress(user.address);
      setEmail(user.email);
    } else if (accessToken) {
      getUserData(accessToken);
    } else {
      setName("n/a");
      setSurname("n/a");
      setAddress("n/a");
      setEmail("n/a");
    }
  }, []);

  // useEffect(() => {
  //   const localUser = JSON.parse(localStorage.getItem("user"));
  //   if (localUser) {
  //     setName(localUser.name);
  //     setSurname(localUser.surname);
  //     setAddress(localUser.address);
  //     setEmail(localUser.email);
  //   } else {
  //     if (!isAuthenticated) {
  //       history.push("/");
  //     }
  //   }

  //   // if (!isAuthenticated) {
  //   //   history.push("/");
  //   // }
  // }, []);

  // useEffect(() => {
  //   if(editUser === false) {
  //     const localUser = JSON.parse(localStorage.getItem("user"));
  //     if (localUser) {
  //       setName(localUser.name);
  //       setSurname(localUser.surname);
  //       setAddress(localUser.address);
  //       setEmail(localUser.email);
  //     }
  //   }
  //   setName(userData?.name ?? "");
  //   setSurname(userData?.surname ?? "");
  //   setAddress(userData?.address ?? "");
  //   setEmail(userData?.email ?? "");
  //   setPassword("");
  //   setVerifyPassword("");

  //   setNameError(null);
  //   setSurnameError(null);
  //   setAddressError(null);
  //   setPasswordError(null);
  //   setVerifyPasswordError(null);
  // }, [editUser, userData]);

  return (
    <Container>
      <MenuWrapper>
        <Menu>{renderMenuItems()}</Menu>
      </MenuWrapper>
      <ContentWrapper tabIndex={0} aria-label="User profile details">
        <UserContent>
          <UserAvatar
            size={64}
            name={userData?.name}
            surname={userData?.surname}
          />
          <UserData>
            <UserHeader>
              <UserTitle>Το Προφίλ μου</UserTitle>
              <EditUserButton
                $isEditEnabled={editUser}
                onClick={() => setEditUser(true)}
              >
                <FormOutlined />
              </EditUserButton>
              <ConfirmEditUserButton
                $isEditEnabled={editUser}
                onClick={() => {
                  handleUserUpdate();
                  setEditUser(false);
                }}
              >
                <CheckOutlined />
              </ConfirmEditUserButton>
              <CancelEditUserButton
                $isEditEnabled={editUser}
                onClick={() => {
                  setName(userData?.name ?? "");
                  setSurname(userData?.surname ?? "");
                  setAddress(userData?.address ?? "");
                  setPassword("");
                  setVerifyPassword("");

                  setEditUser(false);
                }}
              >
                <CloseOutlined />
              </CancelEditUserButton>
            </UserHeader>
            <UserForm>
              <FormRow $isEmail={true}>
                <DisplayItem>
                  <ItemTitle>Email</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {email?.length === 0 ? "n/a" : email}
                  </ItemData>
                  <ItemInput disabled $isEditEnabled={editUser} value={email} />
                </DisplayItem>
              </FormRow>
              <FormRow>
                <DisplayItem>
                  <ItemTitle>Όνομα</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {name?.length === 0 ? "n/a" : name}
                  </ItemData>
                  <ItemInput
                    $isEditEnabled={editUser}
                    value={name}
                    $hasError={nameError}
                    onChange={(event) => {
                      const value = event.target.value;
                      setName(value);
                      setNameError(inputValidation("name", value, name));
                    }}
                  />
                  <ItemError>{nameError}</ItemError>
                </DisplayItem>
                <DisplayItem>
                  <ItemTitle>Επώνυμο</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {surname?.length === 0 ? "n/a" : surname}
                  </ItemData>
                  <ItemInput
                    $isEditEnabled={editUser}
                    value={surname}
                    $hasError={surnameError}
                    onChange={(event) => {
                      const value = event.target.value;
                      setSurname(value);
                      setSurnameError(
                        inputValidation("surname", value, surname),
                      );
                    }}
                  />
                  <ItemError>{surnameError}</ItemError>
                </DisplayItem>
              </FormRow>
              <FormRow>
                <DisplayItem>
                  <ItemTitle>Διεύθυνση</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {address?.length === 0 ? "n/a" : address}
                  </ItemData>
                  <ItemInput
                    $isEditEnabled={editUser}
                    value={address}
                    $hasError={addressError}
                    onChange={(event) => {
                      const value = event.target.value;
                      setAddress(value);
                      setAddressError(
                        inputValidation("address", value, address),
                      );
                    }}
                  />
                  <ItemError>{addressError}</ItemError>
                </DisplayItem>
              </FormRow>
              <FormRow>
                <DisplayItem $isPasswordField={true} $isEditEnabled={editUser}>
                  <ItemTitle>Νέος κωδικός πρόσβασης</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {password?.length === 0 ? "n/a" : password}
                  </ItemData>
                  <ItemInput
                    $isEditEnabled={editUser}
                    value={password}
                    $hasError={passwordError}
                    onChange={(event) => {
                      const value = event.target.value;
                      setPassword(value);
                      setPasswordError(
                        inputValidation("password", value, password),
                      );
                    }}
                  />
                  <ItemError>{passwordError}</ItemError>
                </DisplayItem>
                <DisplayItem $isPasswordField={true} $isEditEnabled={editUser}>
                  <ItemTitle>Επιβεβαίωση κωδικού</ItemTitle>
                  <ItemData $isEditEnabled={editUser}>
                    {verifyPassword?.length === 0 ? "n/a" : verifyPassword}
                  </ItemData>
                  <ItemInput
                    $isEditEnabled={editUser}
                    value={verifyPassword}
                    $hasError={verifyPasswordError}
                    onChange={(event) => {
                      const value = event.target.value;
                      setVerifyPassword(value);
                      setVerifyPasswordError(
                        inputValidation("verifyPassword", value, password),
                      );
                    }}
                  />
                  <ItemError>{verifyPasswordError}</ItemError>
                </DisplayItem>
              </FormRow>
            </UserForm>
          </UserData>
        </UserContent>
      </ContentWrapper>
      <ViewModal
        modalStatus={
          showLogoutModal || showUserEditFailedModal || showUserEditSuccessModal
        }
        title="Επιβεβαίωση αποσυνδεσης"
        closeModal={() => {
          setShowLogoutModal(false);
          setShowUserEditFailedModal(false);
          setShowUserEditSuccessModal(false);
        }}
      >
        {showLogoutModal && (
          <LogoutContent setShowLogoutModal={setShowLogoutModal} />
        )}
        {showUserEditSuccessModal && (
          <p>Οι πληροφορίες χρήστη ενημερώθηκαν επιτυχώς</p>
        )}
        {showUserEditFailedModal && (
          <p>
            Υπήρξε κάποιο πρόβλημα στην ενημέρωση των πληροφορίών χρήστη.
            Παρακαλώ δοκιμάστε αργότερα
          </p>
        )}
      </ViewModal>
    </Container>
  );
};

export default UserProfile;

const Container = styled.div`
  width: 1000px; // width: 65.1vw;
  height: fit-content;
  background: #ffffffee;
  position: absolute;
  top: calc((100% - 500px) / 2);
  left: calc((100% - 1000px) / 2);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  border-radius: 10px;
  box-shadow: 0 0 4px #373b4029;

  @media only screen and (max-width: 1005px) {
    width: 800px;
    left: calc((100% - 800px) / 2);
  }

  @media only screen and (max-width: 808px) {
    width: 400px;
    left: calc((100% - 400px) / 2);
  }

  @media only screen and (max-width: 448px) {
    width: 340px;
    left: calc((100% - 340px) / 2);
  }
`;

const MenuWrapper = styled.div`
  width: 180px;
  height: 510px;
  border-right: 1px solid #373b401f;
  margin: 20px 8px;

  @media only screen and (max-width: 1005px) {
    height: 480px;
  }

  @media only screen and (max-width: 808px) {
    display: none;
  }
`;

const Menu = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MenuItem = styled.div`
  background-color: ${({ $isClickable }) =>
    $isClickable ? "unset" : "#4F82FC1F"};
  cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
  border-radius: 10px;
  width: 100%;
  height: fit-content;

  &:hover {
    color: ${({ $isClickable }) => ($isClickable ? "#4F82FC" : "unset")};
  }
`;

const MenuTitle = styled.div`
  padding: 10px;
`;

const ContentWrapper = styled.div`
  width: 780px;
  height: 510px;
  border: 1px solid #373b401f;
  border-radius: 6px;
  margin: 20px 20px 20px 10px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */

  @media only screen and (max-width: 1005px) {
    height: 480px;
  }

  @media only screen and (max-width: 808px) {
    margin: 20px;
  }
`;

const UserContent = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;

  @media only screen and (max-width: 808px) {
    justify-content: center;
  }
`;

const UserHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
`;

const UserTitle = styled.p`
  font-size: 24px;
  font-weight: 500;

  @media only screen and (max-width: 448px) {
    font-size: 20px;
  }
`;

const EditUserButton = styled.button`
  display: ${({ $isEditEnabled }) => ($isEditEnabled ? "none" : "block")};
  width: 40px;
  height: 40px;
  background-color: #4f82fc1f;
  color: #4f82fc;
  font-size: 20px;
`;
const ConfirmEditUserButton = styled.button`
  display: ${({ $isEditEnabled }) => ($isEditEnabled ? "block" : "none")};
  width: 40px;
  height: 40px;
  background-color: #4f82fc1f;
  color: #4f82fc;
  font-size: 20px;
`;

const CancelEditUserButton = styled.button`
  display: ${({ $isEditEnabled }) => ($isEditEnabled ? "block" : "none")};
  width: 40px;
  height: 40px;
  background-color: #ff00001f;
  color: #ff0000ee;
  font-size: 20px;
`;

const UserData = styled.div``;

const UserForm = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media only screen and (max-width: 808px) {
    align-items: center;
  }
`;

const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 60px;

  @media only screen and (max-width: 808px) {
    flex-direction: column;
    gap: 10px;
    margin-left: ${({ $isEmail }) => ($isEmail ? "-22px" : "unset")};
  }
`;
const DisplayItem = styled.div`
  display: ${({ $isPasswordField, $isEditEnabled }) =>
    $isEditEnabled ? "block" : $isPasswordField ? "none" : "block"};
`;

const ItemTitle = styled.p`
  font-size: 14px;
  color: #373b4099;
  margin-bottom: 4px;
`;

const ItemData = styled.div`
  display: ${({ $isEditEnabled }) => ($isEditEnabled ? "none" : "flex")};
  height: 28px;
  border: 2px solid transparent;
  width: 174px;
  align-items: center;
  font-size: 14px;
`;

const ItemInput = styled.input`
  display: ${({ $isEditEnabled }) => ($isEditEnabled ? "block" : "none")};
  height: 26px;
  border: ${({ $hasError }) =>
    $hasError ? "2px solid red" : "2px solid #00000029"};
  border-radius: 4px;

  &:focus {
    outline: 1px solid #00000069;
  }
`;

const ItemError = styled.p`
  width: 200px;
  font-size: 14px;
  font-weight: 600;
  color: #f00;
`;
